import {
    CriticalPriorityIcon,
    HighPriorityIcon,
    LowPriorityIcon,
    MediumPriorityIcon,
} from '../assets/icons'

export const issueType = [
    {
        label: 'Bug',
        value: 'Bug',
        remove: false,
    },
    {
        label: 'Task',
        value: 'Task',
        remove: false,
    },
]
export const swimLanesType = [
    {
        label: 'To Do',
        value: 'To Do',
        remove: false,
    },
    {
        label: 'Done',
        value: 'Done',
        remove: false,
    },
]

export const priorityType = [
    {
        label: 'Low',
        value: 'Low',
        color: 'green',
    },
    {
        label: 'Medium',
        value: 'Medium',
        color: 'blue',
    },
    {
        label: 'High',
        value: 'High',
        color: 'orange',
    },
    {
        label: 'Critical',
        value: 'Critical',
        color: 'red',
    },
]

// export const issueType = [
//     {
//         label: 'Default',
//         options: [
//             {
//                 label: 'Bug',
//                 value: 'Bug',
//                 remove: false,
//             },
//             {
//                 label: 'Story',
//                 value: 'Story',
//                 remove: false,
//             },
//             {
//                 label: 'Epic',
//                 value: 'Epic',
//                 remove: false,
//             },
//         ],
//     },
//     {
//         label: 'New Added',
//         options: [],
//     },
// ]

// export const priorityType = [
//     { label: 'Low', value: 'Low', color: '#B5EAEA', textColor: '#004B50' },
//     {
//         label: 'Medium',
//         value: 'Medium',
//         color: '#FFEAA7',
//         textColor: '#5A4100',
//     },
//     { label: 'High', value: 'High', color: '#EAB0FF', textColor: '#5B005F' },
//     {
//         label: 'Critical',
//         value: 'Critical',
//         color: '#FFADAD',
//         textColor: '#730000',
//     },
// ]
